// extracted by mini-css-extract-plugin
export default {"appConteiner":"App_appConteiner__y2qTt"};